import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  root: {
    height: 48,
  },
  label: {
    color: "black",
  },
  menu: {
    display: "flex",
    justifyContent: "space-between",
  },
  menuItem: {
    marginRight: theme.spacing(2),
    "&:last-child": {
      marginRight: 0,
    },
  },
  popover: {
    pointerEvents: "none",
  },
  popoverContent: {
    pointerEvents: "auto",
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    border: theme.spacing(2),
    borderRadius: 10,
    boxShadow: "0px 4px 4px rgba(193, 193, 193, 0.25)",
  },
  menuGroupTitle: {
    width: 80,
  },
  partnerMenuGroupTitle: {
    width: 102,
  },
  menuGroupItem: {
    paddingTop: 0,
  },
  caption: {
    ...theme.typography.smallCaption,
  },
  navLink: {
    color: theme.palette.common.grey[800],
    fontWeight: 400,
    textDecoration: "none",
    "&:hover": {
      color: theme.palette.primary.dark,
    },
  },
  hidden: {
    visibility: "hidden",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
}));
